import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, HOW_IT_WORKS_IDS } from '../../../constants';

import { fetchFaqIfNeeded } from '../../../services/faq/actions';
import { fetchContactRequestReasonIfNeeded } from '../../../services/contactrequest/actions';

import HeadComponent from '../../HeadComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import FaqElementComponent from '../faq/FaqElementComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import ContactRequestFormComponent from './ContactRequestFormComponent';

import './ContactRequestPages.scss';

export class ContactRequestPage extends React.Component {
    componentDidMount() {
        this.props.fetchContactRequestReasonIfNeeded();
        this.props.fetchFaqIfNeeded();
    }

    render() {
        const { i18n, faqData } = this.props;

        let faqs = [];
        faqData.map(theme => theme.faqs && theme.faqs.map(faq => faqs.push(faq)));
        const filteredFaqs = faqs.filter(f => HOW_IT_WORKS_IDS.includes(f.id));

        return (
            <main role="main" className="conteneur conteneur-mobile" id="p-contactrequest">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.CONTACTREQUEST_PATH}`}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: i18n.BREADCRUMB,
                            route: PATH.CONTACTREQUEST_PATH
                        }
                    ]}
                />
                <h1>{i18n.PAGE_TITLE}</h1>

                <div className="faq-info">
                    <p>
                        {i18n.TEXT_FAQ_LINK_1}
                        <LocalizedNavLink to={PATH.FAQ_PATH} title={i18n.LINK_FAQ}>
                            {i18n.LINK_FAQ}
                        </LocalizedNavLink>
                        {i18n.TEXT_FAQ_LINK_2}
                    </p>
                </div>

                <ContactRequestFormComponent />

                <hr />

                <div className="help-container-contact grid">
                    <div className="faq-container inbl">
                        <div className="faq-bandeau">
                            <h2>{i18n.QUESTION}</h2>
                            <LinkButtonComponent
                                to={PATH.FAQ_PATH}
                                title={i18n.FREQUENTLY_ASKED_QUESTIONS}
                                color="main"
                                text={i18n.FREQUENTLY_ASKED_QUESTIONS}
                            />
                        </div>
                        <div className="faq-list-container">
                            {filteredFaqs.map(faq => (
                                <FaqElementComponent
                                    key={faq.id}
                                    faq={faq}
                                    cssClass="question-comment-ca-marche-page"
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

ContactRequestPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.CONTACTREQUEST,
        i18nPageHowItWorks: state.i18n.page.HOW_IT_WORKS,
        faqData: state.faq.faqs || []
    };
};

const mapDispatchToProps = {
    fetchContactRequestReasonIfNeeded,
    fetchFaqIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(ContactRequestPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/contactrequest/ContactRequestPage.js